import { Model, belongsTo } from 'miragejs';

export default Model.extend({
  artist: belongsTo('artist', { inverse: 'artistFunctions' }),
  category: belongsTo('category', { inverse: null }),
});
